import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map } from 'rxjs';
import { filterNull } from 'src/util/rxjs/operators/filter-null';

@Injectable({ providedIn: 'root' })
export class UserEmailService {
  private _loginEmail$ = new BehaviorSubject<string>(null as any);
  private _latestEmail$ = new BehaviorSubject<string>(null as any);

  /**
   * Triggers on user login
   */
  public get loginEmail$() {
    return this._loginEmail$.pipe(filterNull(), distinctUntilChanged());
  }
  /**
   * Triggers after impersonation check
   */
  public get latestEmail$() {
    return this._latestEmail$.pipe(filterNull(), distinctUntilChanged());
  }
  /**
   * Triggers on any email changes
   */
  public get emailChanges$() {
    return combineLatest([this.loginEmail$, this._latestEmail$]).pipe(
      map(([loginEmail, latestEmail]) => latestEmail ?? loginEmail),
      distinctUntilChanged(),
    );
  }

  constructor() {}

  public setLoginEmail(email: string) {
    this._loginEmail$.next(email);
  }

  public setLatestEmail(email: string) {
    this._latestEmail$.next(email);
  }
}
